/** City options for tickets filters (UI matches /events; coords used for TEVO search API). */
export const TICKETS_FILTER_CITIES = [
  { label: "All Cities", lat: null, lon: null },
  { label: "Los Angeles, CA", lat: 34.0522, lon: -118.2437 },
  { label: "New York, NY", lat: 40.7128, lon: -74.006 },
  { label: "Las Vegas, NV", lat: 36.1699, lon: -115.1398 },
  { label: "San Francisco, CA", lat: 37.7749, lon: -122.4194 },
  { label: "Boston, MA", lat: 42.3601, lon: -71.0589 },
  { label: "Chicago, IL", lat: 41.8781, lon: -87.6298 },
];

export function getCityByLabel(label) {
  return TICKETS_FILTER_CITIES.find((c) => c.label === label) || TICKETS_FILTER_CITIES[0];
}

export function isAllCities(label) {
  return !label || label === "All Cities";
}

/** Client-side match against venue fields on TEVO / user-created events. */
export function eventMatchesCity(event, cityLabel) {
  if (isAllCities(cityLabel)) return true;

  const parts = cityLabel
    .split(",")
    .map((p) => p.trim().toLowerCase())
    .filter(Boolean);
  const haystack = [
    event?.venue?.name,
    event?.venue?.location,
    event?.venue?.city,
    event?.venue?.state,
    typeof event?.venue === "string" ? event.venue : "",
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return parts.every((part) => haystack.includes(part));
}
